import React from 'react';

import PropTypes from 'prop-types';

import { EMAIL_REQUIRED } from '../../constants/email';

export default class EmailSubscribeForm extends React.PureComponent {
  static propTypes = {
    hasEmail: PropTypes.bool,
    isEUDomains: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
  };

  state = {
    email: '',
    isMarketingEmail: !this.props.isEUDomains,
    emailError: false,
  };

  changeEmail = email => {
    const nextState = {
      email,
      emailError: false,
    };

    this.setState(nextState);
  };

  changeMarketingEmail = checked => {
    this.setState({ isMarketingEmail: checked });
  };

  checkEmail = (state = this.state) => {
    return state.email ? null : EMAIL_REQUIRED;
  };

  handleSubscribe = event => {
    event.preventDefault();
    // Reset errors
    this.setState({
      emailError: false,
    });

    const errors = {
      emailError: this.props.hasEmail ? false : this.checkEmail(),
    };

    if (errors.emailError) {
      return this.setState(errors);
    } else if (this.props.onSubmit) {
      return this.props.onSubmit(this.state.email);
    }
  };

  render() {
    return this.props.render({
      handleSubscribe: this.handleSubscribe,
      onChangeEmail: this.changeEmail,
      hideEmail: this.props.hasEmail,
      hideCheckbox: !this.props.isEUDomains,
      onChangeMarketingEmail: this.changeMarketingEmail,
      email: this.state.email,
      isMarketingEmail: this.state.isMarketingEmail,
      emailError: this.state.emailError,
    });
  }
}
